import "@backstage/cli/asset-types";
import "@backstage/ui/css/styles.css";

import ReactDOM from "react-dom/client";

import app from "./App";

const container = document.getElementById("root");
if (!container) {
    throw new Error('Root element "#root" not found');
}

ReactDOM.createRoot(container).render(app);
